const listeners = new Set();

export const subscribeToAlerts = (listener) => {
  if (typeof listener !== 'function') return () => {};
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const pushAlert = (payload) => {
  listeners.forEach((listener) => listener(payload));
};

export const notify = (message, options = {}) => {
  const text = message === undefined || message === null ? '' : String(message);
  if (!text) return;
  const payload = {
    message: text,
    type: options.type || 'info',
    duration:
      typeof options.duration === 'number' && Number.isFinite(options.duration)
        ? options.duration
        : undefined,
  };
  pushAlert(payload);
};

export default notify;
